/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconMathEqualGreater = createReactComponent("outline", "math-equal-greater", "IconMathEqualGreater", [["path", { "d": "M5 18l14 -4", "key": "svg-0" }], ["path", { "d": "M5 14l14 -4l-14 -4", "key": "svg-1" }]]);

export { IconMathEqualGreater as default };
//# sourceMappingURL=IconMathEqualGreater.mjs.map
